import { Lang } from "./translations";

// Extended translations for all widget/component titles and labels
const componentTranslations: Record<Lang, Record<string, string>> = {
  es: {
    // Component titles
    tokenComparison: "Comparación de Tokens",
    walletGroups: "Grupos de Wallets",
    gasHistory: "Historial de Gas (24h)",
    takeProfitStrategy: "Estrategia Take-Profit",
    portfolioReport: "Informe del Portfolio",
    lendingPositions: "Posiciones de Préstamo",
    receiveCrypto: "Recibir Crypto",
    bridgeTracker: "Monitor de Bridge",
    fundingRates: "Tasas de Financiación",
    governanceVotes: "Votos de Gobernanza",
    airdropTracker: "Rastreador de Airdrops",
    tokenApprovals: "Aprobaciones de Tokens",
    volumeProfile: "Perfil de Volumen",
    crossChainSummary: "Resumen Multi-Chain",
    transactionLabels: "Etiquetas de Transacciones",
    performanceLeaderboard: "Tabla de Rendimiento",
    rewardCalendar: "Calendario de Recompensas",
    whaleTracker: "Rastreador de Ballenas",
    dexRateComparison: "Comparación de DEX",
    positionSizeCalc: "Calculadora de Posición",
    fearGreedIndex: "Índice de Miedo y Codicia",
    contractInspector: "Inspector de Contratos",
    passiveIncome: "Ingresos Pasivos",
    portfolioVersions: "Versiones del Portfolio",
    flashLoanMonitor: "Monitor de Flash Loans",
    liquidationFeed: "Feed de Liquidaciones",
    fibonacciRetracement: "Retroceso Fibonacci",
    stablecoinMonitor: "Monitor de Stablecoins",
    pricePredictions: "Predicciones de Precio",
    securityChecklist: "Checklist de Seguridad",
    watchlist: "Lista de Seguimiento",
    cryptoConverter: "Conversor Crypto",
    addressBook: "Libreta de Direcciones",
    whaleAlerts: "Alertas de Ballenas",
    portfolioTimeline: "Línea de Tiempo",
    gasEstimator: "Estimador de Gas",
    walletComparison: "Comparación de Wallets",
    walletBackup: "Respaldo de Wallet",
    tokenAggregator: "Agregador de Tokens",
    activityHeatmap: "Mapa de Actividad",
    riskScore: "Puntuación de Riesgo",
    chainHistory: "Historial por Cadena",
    sentiment: "Sentimiento",
    feeTracker: "Rastreador de Fees",
    achievements: "Logros",
    portfolioDonut: "Distribución Portfolio",
    sharePortfolio: "Compartir Portfolio",
    eventCountdown: "Cuenta Regresiva",
    chainHealth: "Salud de Cadenas",
    stakingCalculator: "Calculadora de Staking",
    impermanentLoss: "Pérdida Impermanente",
    dcaSimulator: "Simulador DCA",
    correlationMatrix: "Matriz de Correlación",
    goalTracker: "Seguidor de Metas",
    vestingSchedule: "Calendario de Vesting",
    snapshotDiff: "Diferencia de Snapshots",
    taxEstimator: "Estimador de Impuestos",
    multiSigTracker: "Rastreador Multi-Sig",
    yieldFarming: "Yield Farming",
    tokenFlow: "Flujo de Tokens",
    plCalendar: "Calendario P&L",
    liquidationCalc: "Calculadora de Liquidación",
    smartMoneyFeed: "Feed Smart Money",
    rebalanceAdvisor: "Asesor de Rebalanceo",
    benchmarkChart: "Gráfico Benchmark",
    tokenUnlocks: "Desbloqueo de Tokens",
    walletAnalytics: "Analítica de Wallets",
    protocolRevenue: "Ingresos de Protocolo",
    // Common labels
    supplied: "Suministrado",
    borrowed: "Prestado",
    netYield: "Rendimiento Neto",
    claimNow: "Reclamar Ahora",
    claimed: "Reclamado",
    upcoming: "Próximo",
    safe: "Seguro",
    warning: "Advertencia",
    danger: "Peligro",
    active: "Activo",
    passed: "Aprobado",
    failed: "Fallido",
    currentPrice: "Precio Actual",
    confidence: "Confianza",
    safetyScore: "Puntuación de Seguridad",
    overallGrade: "Calificación General",
    daily: "Diario",
    monthly: "Mensual",
    yearly: "Anual",
    current: "Actual",
    compare: "Comparar",
    high: "Alto",
    low: "Bajo",
    avg: "Promedio",
    buy: "Comprar",
    sell: "Vender",
    all: "Todos",
    claimable: "Reclamable",
    risky: "Riesgoso",
    revoke: "Revocar",
    networks: "redes",
    extracted: "extraído",
    bridged: "transferido",
    pending: "Pendiente",
    done: "Hecho",
    storage: "Almacenamiento",
    access: "Acceso",
    backup: "Respaldo",
    phishing: "Phishing",
    smartContracts: "Contratos Inteligentes",
    notFinancialAdvice: "Simulado por IA · No es consejo financiero",
    extremeFear: "Miedo Extremo",
    neutral: "Neutral",
    greed: "Codicia",
    extremeGreed: "Codicia Extrema",
    fear: "Miedo",
    scan: "Escanear",
    positionSize: "Tamaño de Posición",
    maxLoss: "Pérdida Máxima",
    leverage: "Apalancamiento",
    slDistance: "Distancia SL",
    capital: "Capital",
    risk: "Riesgo",
    entryPrice: "Precio de Entrada",
    stopLoss: "Stop Loss",
    trend: "Tendencia",
    uptrend: "Tendencia Alcista",
    downtrend: "Tendencia Bajista",
    units: "Unidades",
    longPosition: "Long",
    shortPosition: "Short",
    totalValue: "Valor Total",
    walletCount: "Wallets",
    chainCount: "Cadenas",
    export: "Exportar",
    add: "Añadir",
    remove: "Eliminar",
    customize: "Personalizar",
    noGroupsYet: "Sin grupos aún. Crea uno para organizar tus wallets.",
    onlySendAssets: "Solo envía activos de {chain} a esta dirección",
    highLeverage: "Alto apalancamiento — riesgo elevado de liquidación",
    gasAboveAvg: "Gas por encima del promedio",
    gasBelowAvg: "Gas por debajo del promedio",
    longsPaying: "Longs pagando a shorts — sesgo alcista",
    shortsPaying: "Shorts pagando a longs — sesgo bajista",
    flashLoanWarning: "Flash loans pueden indicar arbitraje o liquidaciones",
    approvalRevoked: "Aprobación revocada (simulada)",
    allRevoked: "¡Todas las aprobaciones revocadas!",
    // Nuevos componentes #105-#128
    reputationScore: "Puntuación de Reputación",
    portfolioSnapshots: "Instantáneas del Portfolio",
    allowanceRevoker: "Revocador de Permisos",
    whaleAlertFeed: "Feed de Alertas Ballenas",
    multiChainGas: "Gas Multi-Cadena",
    yieldAggregator: "Agregador de Rendimientos",
    insuranceTracker: "Rastreador de Seguros DeFi",
    tokenBurnTracker: "Rastreador de Quemas",
    chainComparison: "Comparación de Cadenas",
    nftFloorTracker: "Rastreador de Floor NFT",
    yieldOptimizerBot: "Bot Optimizador de Yield",
    taxLossHarvesting: "Cosecha de Pérdidas Fiscales",
    perpetualsDashboard: "Dashboard de Perpetuos",
    nftLendingMonitor: "Monitor de Préstamos NFT",
    cryptoOptionsFlow: "Flujo de Opciones Cripto",
    walletMigrationPlanner: "Planificador de Migración",
    realYieldTracker: "Rastreador de Yield Real",
    governancePowerAnalyzer: "Analizador de Poder Governance",
    protocolAuditDashboard: "Dashboard de Auditorías",
    dexVolumeAnalytics: "Análisis de Volumen DEX",
    walletAgeAnalyzer: "Analizador de Antigüedad",
    restakingDashboard: "Dashboard de Restaking",
    pointsProgramTracker: "Rastreador de Puntos",
    memecoinScanner: "Scanner de Memecoins",
    healthFactor: "Factor de Salud",
    fundingRate: "Tasa de Financiación",
    slashRisk: "Riesgo de Slash",
    honeypot: "Honeypot",
    rugScore: "Puntuación Rug",
    auditor: "Auditor",
    bounty: "Bug Bounty",
    realYield: "Yield Real",
    season: "Temporada",
    rank: "Rango",
    votingPower: "Poder de Voto",
    burnRate: "Tasa de Quema",
    floorPrice: "Precio Floor",
    holders: "Holders",
    collateral: "Colateral",
    ltv: "LTV",
    impliedVol: "Vol. Implícita",
    tier: "Nivel",
    delegated: "Delegado",
    marketShare: "Cuota de Mercado",
    openInterest: "Interés Abierto",
    verified: "Verificado",
    unaudited: "Sin Auditar",
    realYieldDesc: "Protocolos con yield real (fees − emisiones)",
    noHoneypot: "Sin Honeypot",
    critical: "Crítico",
    findings: "Hallazgos",
  },
  en: {
    tokenComparison: "Token Comparison",
    walletGroups: "Wallet Groups",
    gasHistory: "Gas Price History (24h)",
    takeProfitStrategy: "Take-Profit Strategy",
    portfolioReport: "Portfolio Report",
    lendingPositions: "Lending Positions",
    receiveCrypto: "Receive Crypto",
    bridgeTracker: "Bridge Tracker",
    fundingRates: "Funding Rates",
    governanceVotes: "Governance Votes",
    airdropTracker: "Airdrop Tracker",
    tokenApprovals: "Token Approvals",
    volumeProfile: "Volume Profile",
    crossChainSummary: "Cross-Chain Summary",
    transactionLabels: "Transaction Labels",
    performanceLeaderboard: "Performance Leaderboard",
    rewardCalendar: "Reward Calendar",
    whaleTracker: "Whale Tracker",
    dexRateComparison: "DEX Rate Comparison",
    positionSizeCalc: "Position Size Calculator",
    fearGreedIndex: "Fear & Greed Index",
    contractInspector: "Contract Inspector",
    passiveIncome: "Passive Income",
    portfolioVersions: "Portfolio Versions",
    flashLoanMonitor: "Flash Loan Monitor",
    liquidationFeed: "Liquidation Feed",
    fibonacciRetracement: "Fibonacci Retracement",
    stablecoinMonitor: "Stablecoin Monitor",
    pricePredictions: "Price Predictions",
    securityChecklist: "Security Checklist",
    watchlist: "Watchlist",
    cryptoConverter: "Crypto Converter",
    addressBook: "Address Book",
    whaleAlerts: "Whale Alerts",
    portfolioTimeline: "Portfolio Timeline",
    gasEstimator: "Gas Estimator",
    walletComparison: "Wallet Comparison",
    walletBackup: "Wallet Backup",
    tokenAggregator: "Token Aggregator",
    activityHeatmap: "Activity Heatmap",
    riskScore: "Risk Score",
    chainHistory: "Chain History",
    sentiment: "Sentiment",
    feeTracker: "Fee Tracker",
    achievements: "Achievements",
    portfolioDonut: "Portfolio Distribution",
    sharePortfolio: "Share Portfolio",
    eventCountdown: "Event Countdown",
    chainHealth: "Chain Health",
    stakingCalculator: "Staking Calculator",
    impermanentLoss: "Impermanent Loss",
    dcaSimulator: "DCA Simulator",
    correlationMatrix: "Correlation Matrix",
    goalTracker: "Goal Tracker",
    vestingSchedule: "Vesting Schedule",
    snapshotDiff: "Snapshot Diff",
    taxEstimator: "Tax Estimator",
    multiSigTracker: "Multi-Sig Tracker",
    yieldFarming: "Yield Farming",
    tokenFlow: "Token Flow",
    plCalendar: "P&L Calendar",
    liquidationCalc: "Liquidation Calculator",
    smartMoneyFeed: "Smart Money Feed",
    rebalanceAdvisor: "Rebalance Advisor",
    benchmarkChart: "Benchmark Chart",
    tokenUnlocks: "Token Unlocks",
    walletAnalytics: "Wallet Analytics",
    protocolRevenue: "Protocol Revenue",
    supplied: "Supplied",
    borrowed: "Borrowed",
    netYield: "Net Yield",
    claimNow: "Claim Now",
    claimed: "Claimed",
    upcoming: "Upcoming",
    safe: "Safe",
    warning: "Warning",
    danger: "Danger",
    active: "Active",
    passed: "Passed",
    failed: "Failed",
    currentPrice: "Current Price",
    confidence: "Confidence",
    safetyScore: "Safety Score",
    overallGrade: "Overall Grade",
    daily: "Daily",
    monthly: "Monthly",
    yearly: "Yearly",
    current: "Current",
    compare: "Compare",
    high: "High",
    low: "Low",
    avg: "Avg",
    buy: "Buy",
    sell: "Sell",
    all: "All",
    claimable: "Claimable",
    risky: "risky",
    revoke: "Revoke",
    networks: "networks",
    extracted: "extracted",
    bridged: "bridged",
    pending: "Pending",
    done: "Done",
    storage: "Storage",
    access: "Access",
    backup: "Backup",
    phishing: "Phishing",
    smartContracts: "Smart Contracts",
    notFinancialAdvice: "AI simulated · Not financial advice",
    extremeFear: "Extreme Fear",
    neutral: "Neutral",
    greed: "Greed",
    extremeGreed: "Extreme Greed",
    fear: "Fear",
    scan: "Scan",
    positionSize: "Position Size",
    maxLoss: "Max Loss",
    leverage: "Leverage",
    slDistance: "SL Distance",
    capital: "Capital",
    risk: "Risk",
    entryPrice: "Entry Price",
    stopLoss: "Stop Loss",
    trend: "Trend",
    uptrend: "↑ Uptrend",
    downtrend: "↓ Downtrend",
    units: "Units",
    longPosition: "Long",
    shortPosition: "Short",
    totalValue: "Total Portfolio Value",
    walletCount: "Wallets",
    chainCount: "Chains",
    export: "Export",
    add: "Add",
    remove: "Remove",
    customize: "Customize",
    noGroupsYet: "No groups yet. Create one to organize your wallets.",
    onlySendAssets: "Only send {chain} assets to this address",
    highLeverage: "High leverage — elevated liquidation risk",
    gasAboveAvg: "Gas is above average",
    gasBelowAvg: "Gas is below average",
    longsPaying: "Longs paying shorts — bullish bias",
    shortsPaying: "Shorts paying longs — bearish bias",
    flashLoanWarning: "Flash loans may indicate arbitrage or liquidation events",
    approvalRevoked: "Approval revoked (simulated)",
    allRevoked: "All approvals revoked!",
    // New components #105-#128
    reputationScore: "Reputation Score",
    portfolioSnapshots: "Portfolio Snapshots",
    allowanceRevoker: "Allowance Revoker",
    whaleAlertFeed: "Whale Alert Feed",
    multiChainGas: "Multi-Chain Gas Dashboard",
    yieldAggregator: "Yield Aggregator",
    insuranceTracker: "DeFi Insurance Tracker",
    tokenBurnTracker: "Token Burn Tracker",
    chainComparison: "Chain Comparison",
    nftFloorTracker: "NFT Floor Tracker",
    yieldOptimizerBot: "Yield Optimizer Bot",
    taxLossHarvesting: "Tax Loss Harvesting",
    perpetualsDashboard: "Perpetuals Dashboard",
    nftLendingMonitor: "NFT Lending Monitor",
    cryptoOptionsFlow: "Options Flow Tracker",
    walletMigrationPlanner: "Wallet Migration Planner",
    realYieldTracker: "Real Yield Tracker",
    governancePowerAnalyzer: "Governance Power Analyzer",
    protocolAuditDashboard: "Protocol Audit Dashboard",
    dexVolumeAnalytics: "DEX Volume Analytics",
    walletAgeAnalyzer: "Wallet Age Analyzer",
    restakingDashboard: "Restaking Dashboard",
    pointsProgramTracker: "Points Program Tracker",
    memecoinScanner: "Memecoin Scanner",
    healthFactor: "Health Factor",
    fundingRate: "Funding Rate",
    slashRisk: "Slash Risk",
    honeypot: "Honeypot",
    rugScore: "Rug Score",
    auditor: "Auditor",
    bounty: "Bug Bounty",
    realYield: "Real Yield",
    season: "Season",
    rank: "Rank",
    votingPower: "Voting Power",
    burnRate: "Burn Rate",
    floorPrice: "Floor Price",
    holders: "Holders",
    collateral: "Collateral",
    ltv: "LTV",
    impliedVol: "Implied Vol",
    tier: "Tier",
    delegated: "Delegated",
    marketShare: "Market Share",
    openInterest: "Open Interest",
    verified: "Verified",
    unaudited: "Unaudited",
    realYieldDesc: "Protocols ranked by real yield (fees − emissions)",
    noHoneypot: "No Honeypot",
    critical: "Critical",
    findings: "Findings",
  },
  zh: {
    tokenComparison: "代币对比",
    walletGroups: "钱包分组",
    gasHistory: "Gas价格历史 (24h)",
    takeProfitStrategy: "止盈策略",
    portfolioReport: "投资组合报告",
    lendingPositions: "借贷仓位",
    receiveCrypto: "接收加密货币",
    bridgeTracker: "跨链追踪",
    fundingRates: "资金费率",
    governanceVotes: "治理投票",
    airdropTracker: "空投追踪",
    tokenApprovals: "代币授权",
    volumeProfile: "成交量分布",
    crossChainSummary: "多链摘要",
    transactionLabels: "交易标签",
    performanceLeaderboard: "业绩排行榜",
    rewardCalendar: "奖励日历",
    whaleTracker: "巨鲸追踪",
    dexRateComparison: "DEX价格对比",
    positionSizeCalc: "仓位计算器",
    fearGreedIndex: "恐惧与贪婪指数",
    contractInspector: "合约检查器",
    passiveIncome: "被动收入",
    portfolioVersions: "组合版本对比",
    flashLoanMonitor: "闪电贷监控",
    liquidationFeed: "清算信息流",
    fibonacciRetracement: "斐波那契回撤",
    stablecoinMonitor: "稳定币监控",
    pricePredictions: "价格预测",
    securityChecklist: "安全清单",
    watchlist: "关注列表",
    cryptoConverter: "加密货币转换器",
    addressBook: "地址簿",
    whaleAlerts: "巨鲸警报",
    portfolioTimeline: "组合时间线",
    gasEstimator: "Gas估算",
    walletComparison: "钱包对比",
    walletBackup: "钱包备份",
    tokenAggregator: "代币聚合",
    activityHeatmap: "活动热力图",
    riskScore: "风险评分",
    chainHistory: "链历史",
    sentiment: "市场情绪",
    feeTracker: "费用追踪",
    achievements: "成就",
    portfolioDonut: "组合分布",
    sharePortfolio: "分享组合",
    eventCountdown: "事件倒计时",
    chainHealth: "链健康",
    stakingCalculator: "质押计算器",
    impermanentLoss: "无常损失",
    dcaSimulator: "DCA模拟器",
    correlationMatrix: "相关性矩阵",
    goalTracker: "目标追踪",
    vestingSchedule: "归属计划",
    snapshotDiff: "快照差异",
    taxEstimator: "税务估算",
    multiSigTracker: "多签追踪",
    yieldFarming: "收益耕作",
    tokenFlow: "代币流向",
    plCalendar: "盈亏日历",
    liquidationCalc: "清算计算器",
    smartMoneyFeed: "聪明钱信息流",
    rebalanceAdvisor: "再平衡建议",
    benchmarkChart: "基准图表",
    tokenUnlocks: "代币解锁",
    walletAnalytics: "钱包分析",
    protocolRevenue: "协议收入",
    supplied: "供应",
    borrowed: "借入",
    netYield: "净收益",
    claimNow: "立即领取",
    claimed: "已领取",
    upcoming: "即将到来",
    safe: "安全",
    warning: "警告",
    danger: "危险",
    active: "进行中",
    passed: "已通过",
    failed: "未通过",
    currentPrice: "当前价格",
    confidence: "置信度",
    safetyScore: "安全评分",
    overallGrade: "综合评级",
    daily: "每日",
    monthly: "每月",
    yearly: "每年",
    current: "当前",
    compare: "对比",
    high: "高",
    low: "低",
    avg: "均值",
    buy: "买入",
    sell: "卖出",
    all: "全部",
    claimable: "可领取",
    risky: "高风险",
    revoke: "撤销",
    networks: "个网络",
    extracted: "已提取",
    bridged: "已跨链",
    pending: "待处理",
    done: "完成",
    storage: "存储",
    access: "访问",
    backup: "备份",
    phishing: "钓鱼防护",
    smartContracts: "智能合约",
    notFinancialAdvice: "AI模拟 · 非投资建议",
    extremeFear: "极度恐惧",
    neutral: "中性",
    greed: "贪婪",
    extremeGreed: "极度贪婪",
    fear: "恐惧",
    scan: "扫描",
    positionSize: "仓位大小",
    maxLoss: "最大亏损",
    leverage: "杠杆",
    slDistance: "止损距离",
    capital: "资金",
    risk: "风险",
    entryPrice: "入场价",
    stopLoss: "止损",
    trend: "趋势",
    uptrend: "↑ 上升趋势",
    downtrend: "↓ 下降趋势",
    units: "数量",
    longPosition: "做多",
    shortPosition: "做空",
    totalValue: "组合总价值",
    walletCount: "钱包",
    chainCount: "链",
    export: "导出",
    add: "添加",
    remove: "删除",
    customize: "自定义",
    noGroupsYet: "还没有分组。创建一个来整理你的钱包。",
    onlySendAssets: "只发送 {chain} 资产到此地址",
    highLeverage: "高杠杆 — 清算风险升高",
    gasAboveAvg: "Gas高于平均",
    gasBelowAvg: "Gas低于平均",
    longsPaying: "多头支付空头 — 看涨倾向",
    shortsPaying: "空头支付多头 — 看跌倾向",
    flashLoanWarning: "闪电贷可能表示套利或清算事件",
    approvalRevoked: "授权已撤销（模拟）",
    allRevoked: "所有授权已撤销！",
    reputationScore: "声誉评分",
    portfolioSnapshots: "组合快照",
    allowanceRevoker: "授权撤销器",
    whaleAlertFeed: "巨鲸预警",
    multiChainGas: "多链Gas面板",
    yieldAggregator: "收益聚合器",
    insuranceTracker: "DeFi保险追踪",
    tokenBurnTracker: "代币销毁追踪",
    chainComparison: "链对比",
    nftFloorTracker: "NFT底价追踪",
    yieldOptimizerBot: "收益优化机器人",
    taxLossHarvesting: "税损收割",
    perpetualsDashboard: "永续合约面板",
    nftLendingMonitor: "NFT借贷监控",
    cryptoOptionsFlow: "期权流量追踪",
    walletMigrationPlanner: "钱包迁移规划",
    realYieldTracker: "真实收益追踪",
    governancePowerAnalyzer: "治理权力分析",
    protocolAuditDashboard: "审计面板",
    dexVolumeAnalytics: "DEX交易量分析",
    walletAgeAnalyzer: "钱包年龄分析",
    restakingDashboard: "再质押面板",
    pointsProgramTracker: "积分项目追踪",
    memecoinScanner: "Meme币扫描",
    healthFactor: "健康因子",
    fundingRate: "资金费率",
    slashRisk: "罚没风险",
    honeypot: "蜜罐",
    rugScore: "跑路评分",
    auditor: "审计方",
    bounty: "漏洞奖励",
    realYield: "真实收益",
    season: "赛季",
    rank: "排名",
    votingPower: "投票权",
    burnRate: "销毁速率",
    floorPrice: "底价",
    holders: "持有者",
    collateral: "抵押品",
    ltv: "贷款价值比",
    impliedVol: "隐含波动率",
    tier: "等级",
    delegated: "已委托",
    marketShare: "市场份额",
    openInterest: "未平仓量",
    verified: "已验证",
    unaudited: "未审计",
    realYieldDesc: "按真实收益排名（手续费−代币释放）",
    noHoneypot: "无蜜罐",
    critical: "严重",
    findings: "发现",
  },
  hi: {
    tokenComparison: "टोकन तुलना",
    walletGroups: "वॉलेट समूह",
    gasHistory: "Gas मूल्य इतिहास (24h)",
    takeProfitStrategy: "टेक-प्रॉफिट रणनीति",
    portfolioReport: "पोर्टफोलियो रिपोर्ट",
    lendingPositions: "लेंडिंग पोज़ीशन",
    receiveCrypto: "क्रिप्टो प्राप्त करें",
    bridgeTracker: "ब्रिज ट्रैकर",
    fundingRates: "फंडिंग दरें",
    governanceVotes: "गवर्नेंस वोट",
    airdropTracker: "एयरड्रॉप ट्रैकर",
    tokenApprovals: "टोकन अनुमोदन",
    volumeProfile: "वॉल्यूम प्रोफ़ाइल",
    crossChainSummary: "क्रॉस-चेन सारांश",
    transactionLabels: "लेनदेन लेबल",
    performanceLeaderboard: "प्रदर्शन लीडरबोर्ड",
    rewardCalendar: "पुरस्कार कैलेंडर",
    whaleTracker: "व्हेल ट्रैकर",
    dexRateComparison: "DEX दर तुलना",
    positionSizeCalc: "पोज़ीशन साइज़ कैलकुलेटर",
    fearGreedIndex: "भय और लालच सूचकांक",
    contractInspector: "कॉन्ट्रैक्ट इंस्पेक्टर",
    passiveIncome: "निष्क्रिय आय",
    portfolioVersions: "पोर्टफोलियो संस्करण",
    flashLoanMonitor: "फ्लैश लोन मॉनिटर",
    liquidationFeed: "लिक्विडेशन फ़ीड",
    fibonacciRetracement: "फिबोनाची रिट्रेसमेंट",
    stablecoinMonitor: "स्टेबलकॉइन मॉनिटर",
    pricePredictions: "मूल्य भविष्यवाणी",
    securityChecklist: "सुरक्षा चेकलिस्ट",
    watchlist: "वॉचलिस्ट",
    cryptoConverter: "क्रिप्टो कनवर्टर",
    addressBook: "पता पुस्तिका",
    whaleAlerts: "व्हेल अलर्ट",
    portfolioTimeline: "पोर्टफोलियो टाइमलाइन",
    gasEstimator: "Gas अनुमानक",
    walletComparison: "वॉलेट तुलना",
    walletBackup: "वॉलेट बैकअप",
    tokenAggregator: "टोकन एग्रीगेटर",
    activityHeatmap: "गतिविधि हीटमैप",
    riskScore: "जोखिम स्कोर",
    chainHistory: "चेन इतिहास",
    sentiment: "भावना",
    feeTracker: "शुल्क ट्रैकर",
    achievements: "उपलब्धियाँ",
    portfolioDonut: "पोर्टफोलियो वितरण",
    sharePortfolio: "पोर्टफोलियो साझा करें",
    eventCountdown: "इवेंट काउंटडाउन",
    chainHealth: "चेन स्वास्थ्य",
    stakingCalculator: "स्टेकिंग कैलकुलेटर",
    impermanentLoss: "अस्थायी हानि",
    dcaSimulator: "DCA सिम्युलेटर",
    correlationMatrix: "सहसंबंध मैट्रिक्स",
    goalTracker: "लक्ष्य ट्रैकर",
    vestingSchedule: "वेस्टिंग शेड्यूल",
    snapshotDiff: "स्नैपशॉट अंतर",
    taxEstimator: "कर अनुमानक",
    multiSigTracker: "मल्टी-सिग ट्रैकर",
    yieldFarming: "यील्ड फार्मिंग",
    tokenFlow: "टोकन प्रवाह",
    plCalendar: "P&L कैलेंडर",
    liquidationCalc: "लिक्विडेशन कैलकुलेटर",
    smartMoneyFeed: "स्मार्ट मनी फ़ीड",
    rebalanceAdvisor: "रीबैलेंस सलाहकार",
    benchmarkChart: "बेंचमार्क चार्ट",
    tokenUnlocks: "टोकन अनलॉक",
    walletAnalytics: "वॉलेट एनालिटिक्स",
    protocolRevenue: "प्रोटोकॉल राजस्व",
    supplied: "आपूर्ति",
    borrowed: "उधार",
    netYield: "शुद्ध प्रतिफल",
    claimNow: "अभी दावा करें",
    claimed: "दावा किया",
    upcoming: "आगामी",
    safe: "सुरक्षित",
    warning: "चेतावनी",
    danger: "खतरा",
    active: "सक्रिय",
    passed: "पारित",
    failed: "विफल",
    currentPrice: "वर्तमान मूल्य",
    confidence: "विश्वास",
    safetyScore: "सुरक्षा स्कोर",
    overallGrade: "समग्र ग्रेड",
    daily: "दैनिक",
    monthly: "मासिक",
    yearly: "वार्षिक",
    current: "वर्तमान",
    compare: "तुलना",
    high: "उच्च",
    low: "निम्न",
    avg: "औसत",
    buy: "खरीदें",
    sell: "बेचें",
    all: "सभी",
    claimable: "दावा योग्य",
    risky: "जोखिमपूर्ण",
    revoke: "रद्द करें",
    networks: "नेटवर्क",
    extracted: "निकाला गया",
    bridged: "ब्रिज किया",
    pending: "लंबित",
    done: "पूर्ण",
    storage: "भंडारण",
    access: "पहुँच",
    backup: "बैकअप",
    phishing: "फ़िशिंग",
    smartContracts: "स्मार्ट कॉन्ट्रैक्ट",
    notFinancialAdvice: "AI सिम्युलेटेड · वित्तीय सलाह नहीं",
    extremeFear: "अत्यधिक भय",
    neutral: "तटस्थ",
    greed: "लालच",
    extremeGreed: "अत्यधिक लालच",
    fear: "भय",
    scan: "स्कैन",
    positionSize: "पोज़ीशन का आकार",
    maxLoss: "अधिकतम हानि",
    leverage: "लीवरेज",
    slDistance: "SL दूरी",
    capital: "पूंजी",
    risk: "जोखिम",
    entryPrice: "प्रवेश मूल्य",
    stopLoss: "स्टॉप लॉस",
    trend: "रुझान",
    uptrend: "↑ तेजी",
    downtrend: "↓ मंदी",
    units: "इकाइयाँ",
    longPosition: "लॉन्ग",
    shortPosition: "शॉर्ट",
    totalValue: "कुल पोर्टफोलियो मूल्य",
    walletCount: "वॉलेट",
    chainCount: "चेन",
    export: "निर्यात",
    add: "जोड़ें",
    remove: "हटाएँ",
    customize: "अनुकूलित",
    noGroupsYet: "अभी कोई समूह नहीं। अपने वॉलेट व्यवस्थित करने के लिए बनाएं।",
    onlySendAssets: "इस पते पर केवल {chain} संपत्ति भेजें",
    highLeverage: "उच्च लीवरेज — लिक्विडेशन का बढ़ा हुआ जोखिम",
    gasAboveAvg: "Gas औसत से ऊपर",
    gasBelowAvg: "Gas औसत से नीचे",
    longsPaying: "लॉन्ग शॉर्ट को भुगतान कर रहे — तेजी का रुझान",
    shortsPaying: "शॉर्ट लॉन्ग को भुगतान कर रहे — मंदी का रुझान",
    flashLoanWarning: "फ्लैश लोन आर्बिट्राज या लिक्विडेशन का संकेत हो सकते हैं",
    approvalRevoked: "अनुमोदन रद्द (सिम्युलेटेड)",
    allRevoked: "सभी अनुमोदन रद्द!",
    reputationScore: "प्रतिष्ठा स्कोर",
    portfolioSnapshots: "पोर्टफोलियो स्नैपशॉट",
    allowanceRevoker: "अनुमति रद्दकर्ता",
    whaleAlertFeed: "व्हेल अलर्ट फ़ीड",
    multiChainGas: "मल्टी-चेन Gas",
    yieldAggregator: "यील्ड एग्रीगेटर",
    insuranceTracker: "DeFi बीमा ट्रैकर",
    tokenBurnTracker: "टोकन बर्न ट्रैकर",
    chainComparison: "चेन तुलना",
    nftFloorTracker: "NFT फ्लोर ट्रैकर",
    yieldOptimizerBot: "यील्ड ऑप्टिमाइज़र बॉट",
    taxLossHarvesting: "टैक्स लॉस हार्वेस्टिंग",
    perpetualsDashboard: "परपेचुअल्स डैशबोर्ड",
    nftLendingMonitor: "NFT लेंडिंग मॉनिटर",
    cryptoOptionsFlow: "ऑप्शंस फ्लो ट्रैकर",
    walletMigrationPlanner: "वॉलेट माइग्रेशन",
    realYieldTracker: "रियल यील्ड ट्रैकर",
    governancePowerAnalyzer: "गवर्नेंस पावर",
    protocolAuditDashboard: "ऑडिट डैशबोर्ड",
    dexVolumeAnalytics: "DEX वॉल्यूम एनालिटिक्स",
    walletAgeAnalyzer: "वॉलेट आयु विश्लेषक",
    restakingDashboard: "रीस्टेकिंग डैशबोर्ड",
    pointsProgramTracker: "पॉइंट्स प्रोग्राम",
    memecoinScanner: "मीमकॉइन स्कैनर",
    healthFactor: "स्वास्थ्य कारक",
    fundingRate: "फंडिंग दर",
    slashRisk: "स्लैश जोखिम",
    honeypot: "हनीपॉट",
    rugScore: "रग स्कोर",
    auditor: "ऑडिटर",
    bounty: "बग बाउंटी",
    realYield: "रियल यील्ड",
    season: "सीजन",
    rank: "रैंक",
    votingPower: "मतदान शक्ति",
    burnRate: "बर्न दर",
    floorPrice: "फ्लोर प्राइस",
    holders: "धारक",
    collateral: "कोलैटरल",
    ltv: "LTV",
    impliedVol: "इंप्लाइड वोल",
    tier: "स्तर",
    delegated: "प्रत्यायोजित",
    marketShare: "बाजार हिस्सा",
    openInterest: "ओपन इंटरेस्ट",
    verified: "सत्यापित",
    unaudited: "अनऑडिटेड",
    realYieldDesc: "वास्तविक यील्ड द्वारा रैंक (फीस − उत्सर्जन)",
    noHoneypot: "हनीपॉट नहीं",
    critical: "क्रिटिकल",
    findings: "निष्कर्ष",
  },
  ar: {
    tokenComparison: "مقارنة الرموز",
    walletGroups: "مجموعات المحافظ",
    gasHistory: "تاريخ سعر Gas (24 ساعة)",
    takeProfitStrategy: "استراتيجية جني الأرباح",
    portfolioReport: "تقرير المحفظة",
    lendingPositions: "مراكز الإقراض",
    receiveCrypto: "استلام العملات",
    bridgeTracker: "متتبع الجسر",
    fundingRates: "معدلات التمويل",
    governanceVotes: "تصويت الحوكمة",
    airdropTracker: "متتبع الإيردروب",
    tokenApprovals: "موافقات الرموز",
    volumeProfile: "ملف الحجم",
    crossChainSummary: "ملخص متعدد السلاسل",
    transactionLabels: "تسميات المعاملات",
    performanceLeaderboard: "لوحة الأداء",
    rewardCalendar: "تقويم المكافآت",
    whaleTracker: "متتبع الحيتان",
    dexRateComparison: "مقارنة أسعار DEX",
    positionSizeCalc: "حاسبة حجم المركز",
    fearGreedIndex: "مؤشر الخوف والطمع",
    contractInspector: "فاحص العقود",
    passiveIncome: "الدخل السلبي",
    portfolioVersions: "إصدارات المحفظة",
    flashLoanMonitor: "مراقب القروض السريعة",
    liquidationFeed: "تغذية التصفية",
    fibonacciRetracement: "ارتداد فيبوناتشي",
    stablecoinMonitor: "مراقب العملات المستقرة",
    pricePredictions: "توقعات الأسعار",
    securityChecklist: "قائمة الأمان",
    watchlist: "قائمة المراقبة",
    cryptoConverter: "محول العملات",
    addressBook: "دفتر العناوين",
    whaleAlerts: "تنبيهات الحيتان",
    portfolioTimeline: "الجدول الزمني",
    gasEstimator: "مقدر Gas",
    walletComparison: "مقارنة المحافظ",
    walletBackup: "نسخ احتياطي",
    tokenAggregator: "مجمع الرموز",
    activityHeatmap: "خريطة النشاط",
    riskScore: "درجة المخاطر",
    chainHistory: "تاريخ السلسلة",
    sentiment: "المعنويات",
    feeTracker: "متتبع الرسوم",
    achievements: "الإنجازات",
    portfolioDonut: "توزيع المحفظة",
    sharePortfolio: "مشاركة المحفظة",
    eventCountdown: "العد التنازلي",
    chainHealth: "صحة السلسلة",
    stakingCalculator: "حاسبة التخزين",
    impermanentLoss: "الخسارة غير الدائمة",
    dcaSimulator: "محاكي DCA",
    correlationMatrix: "مصفوفة الارتباط",
    goalTracker: "متتبع الأهداف",
    vestingSchedule: "جدول الاستحقاق",
    snapshotDiff: "فرق اللقطات",
    taxEstimator: "مقدر الضرائب",
    multiSigTracker: "متتبع التوقيع المتعدد",
    yieldFarming: "زراعة العائد",
    tokenFlow: "تدفق الرموز",
    plCalendar: "تقويم الأرباح والخسائر",
    liquidationCalc: "حاسبة التصفية",
    smartMoneyFeed: "تغذية الأموال الذكية",
    rebalanceAdvisor: "مستشار إعادة التوازن",
    benchmarkChart: "مخطط المعيار",
    tokenUnlocks: "فتح الرموز",
    walletAnalytics: "تحليلات المحفظة",
    protocolRevenue: "إيرادات البروتوكول",
    supplied: "مُقدم",
    borrowed: "مُقترض",
    netYield: "العائد الصافي",
    claimNow: "اطلب الآن",
    claimed: "تم الطلب",
    upcoming: "قادم",
    safe: "آمن",
    warning: "تحذير",
    danger: "خطر",
    active: "نشط",
    passed: "تمت الموافقة",
    failed: "فشل",
    currentPrice: "السعر الحالي",
    confidence: "الثقة",
    safetyScore: "درجة الأمان",
    overallGrade: "التقييم العام",
    daily: "يومي",
    monthly: "شهري",
    yearly: "سنوي",
    current: "الحالي",
    compare: "مقارنة",
    high: "مرتفع",
    low: "منخفض",
    avg: "متوسط",
    buy: "شراء",
    sell: "بيع",
    all: "الكل",
    claimable: "قابل للمطالبة",
    risky: "خطير",
    revoke: "إلغاء",
    networks: "شبكات",
    extracted: "مستخرج",
    bridged: "محول",
    pending: "قيد الانتظار",
    done: "تم",
    storage: "التخزين",
    access: "الوصول",
    backup: "النسخ الاحتياطي",
    phishing: "التصيد",
    smartContracts: "العقود الذكية",
    notFinancialAdvice: "محاكاة AI · ليست نصيحة مالية",
    extremeFear: "خوف شديد",
    neutral: "محايد",
    greed: "طمع",
    extremeGreed: "طمع شديد",
    fear: "خوف",
    scan: "فحص",
    positionSize: "حجم المركز",
    maxLoss: "أقصى خسارة",
    leverage: "الرافعة المالية",
    slDistance: "مسافة وقف الخسارة",
    capital: "رأس المال",
    risk: "المخاطر",
    entryPrice: "سعر الدخول",
    stopLoss: "وقف الخسارة",
    trend: "الاتجاه",
    uptrend: "↑ صاعد",
    downtrend: "↓ هابط",
    units: "وحدات",
    longPosition: "شراء",
    shortPosition: "بيع",
    totalValue: "القيمة الإجمالية",
    walletCount: "المحافظ",
    chainCount: "السلاسل",
    export: "تصدير",
    add: "إضافة",
    remove: "إزالة",
    customize: "تخصيص",
    noGroupsYet: "لا توجد مجموعات بعد. أنشئ واحدة لتنظيم محافظك.",
    onlySendAssets: "أرسل فقط أصول {chain} إلى هذا العنوان",
    highLeverage: "رافعة مالية عالية — خطر تصفية مرتفع",
    gasAboveAvg: "Gas أعلى من المتوسط",
    gasBelowAvg: "Gas أقل من المتوسط",
    longsPaying: "المشترون يدفعون للبائعين — ميل صعودي",
    shortsPaying: "البائعون يدفعون للمشترين — ميل هبوطي",
    flashLoanWarning: "القروض السريعة قد تشير إلى مراجحة أو تصفية",
    approvalRevoked: "تم إلغاء الموافقة (محاكاة)",
    allRevoked: "تم إلغاء جميع الموافقات!",
    reputationScore: "درجة السمعة",
    portfolioSnapshots: "لقطات المحفظة",
    allowanceRevoker: "إلغاء الأذونات",
    whaleAlertFeed: "تنبيهات الحيتان",
    multiChainGas: "Gas متعدد السلاسل",
    yieldAggregator: "مجمع العائد",
    insuranceTracker: "تتبع تأمين DeFi",
    tokenBurnTracker: "متتبع حرق الرموز",
    chainComparison: "مقارنة السلاسل",
    nftFloorTracker: "متتبع أسعار NFT",
    yieldOptimizerBot: "روبوت تحسين العائد",
    taxLossHarvesting: "حصاد الخسائر الضريبية",
    perpetualsDashboard: "لوحة العقود الدائمة",
    nftLendingMonitor: "مراقب إقراض NFT",
    cryptoOptionsFlow: "تدفق الخيارات",
    walletMigrationPlanner: "مخطط ترحيل المحفظة",
    realYieldTracker: "متتبع العائد الحقيقي",
    governancePowerAnalyzer: "محلل قوة الحوكمة",
    protocolAuditDashboard: "لوحة التدقيق",
    dexVolumeAnalytics: "تحليل حجم DEX",
    walletAgeAnalyzer: "محلل عمر المحفظة",
    restakingDashboard: "لوحة إعادة التخزين",
    pointsProgramTracker: "متتبع برامج النقاط",
    memecoinScanner: "ماسح ميم كوين",
    healthFactor: "عامل الصحة",
    fundingRate: "معدل التمويل",
    slashRisk: "مخاطر الخفض",
    honeypot: "فخ العسل",
    rugScore: "درجة الاحتيال",
    auditor: "المدقق",
    bounty: "مكافأة الأخطاء",
    realYield: "العائد الحقيقي",
    season: "الموسم",
    rank: "الترتيب",
    votingPower: "قوة التصويت",
    burnRate: "معدل الحرق",
    floorPrice: "السعر الأدنى",
    holders: "الحاملون",
    collateral: "الضمان",
    ltv: "نسبة القرض للقيمة",
    impliedVol: "التقلب الضمني",
    tier: "المستوى",
    delegated: "مفوض",
    marketShare: "حصة السوق",
    openInterest: "الفائدة المفتوحة",
    verified: "موثق",
    unaudited: "غير مدقق",
    realYieldDesc: "البروتوكولات مرتبة حسب العائد الحقيقي",
    noHoneypot: "لا يوجد فخ",
    critical: "حرج",
    findings: "النتائج",
  },
  pt: {
    tokenComparison: "Comparação de Tokens",
    walletGroups: "Grupos de Carteiras",
    gasHistory: "Histórico de Gas (24h)",
    takeProfitStrategy: "Estratégia Take-Profit",
    portfolioReport: "Relatório do Portfólio",
    lendingPositions: "Posições de Empréstimo",
    receiveCrypto: "Receber Crypto",
    bridgeTracker: "Monitor de Bridge",
    fundingRates: "Taxas de Financiamento",
    governanceVotes: "Votos de Governança",
    airdropTracker: "Rastreador de Airdrops",
    tokenApprovals: "Aprovações de Tokens",
    volumeProfile: "Perfil de Volume",
    crossChainSummary: "Resumo Multi-Chain",
    transactionLabels: "Rótulos de Transações",
    performanceLeaderboard: "Ranking de Desempenho",
    rewardCalendar: "Calendário de Recompensas",
    whaleTracker: "Rastreador de Baleias",
    dexRateComparison: "Comparação de DEX",
    positionSizeCalc: "Calculadora de Posição",
    fearGreedIndex: "Índice de Medo e Ganância",
    contractInspector: "Inspetor de Contratos",
    passiveIncome: "Renda Passiva",
    portfolioVersions: "Versões do Portfólio",
    flashLoanMonitor: "Monitor de Flash Loans",
    liquidationFeed: "Feed de Liquidações",
    fibonacciRetracement: "Retração Fibonacci",
    stablecoinMonitor: "Monitor de Stablecoins",
    pricePredictions: "Previsões de Preço",
    securityChecklist: "Checklist de Segurança",
    watchlist: "Lista de Observação",
    cryptoConverter: "Conversor Crypto",
    addressBook: "Agenda de Endereços",
    whaleAlerts: "Alertas de Baleias",
    portfolioTimeline: "Linha do Tempo",
    gasEstimator: "Estimador de Gas",
    walletComparison: "Comparação de Carteiras",
    walletBackup: "Backup de Carteira",
    tokenAggregator: "Agregador de Tokens",
    activityHeatmap: "Mapa de Atividade",
    riskScore: "Pontuação de Risco",
    chainHistory: "Histórico da Rede",
    sentiment: "Sentimento",
    feeTracker: "Rastreador de Taxas",
    achievements: "Conquistas",
    portfolioDonut: "Distribuição do Portfólio",
    sharePortfolio: "Compartilhar Portfólio",
    eventCountdown: "Contagem Regressiva",
    chainHealth: "Saúde da Rede",
    stakingCalculator: "Calculadora de Staking",
    impermanentLoss: "Perda Impermanente",
    dcaSimulator: "Simulador DCA",
    correlationMatrix: "Matriz de Correlação",
    goalTracker: "Rastreador de Metas",
    vestingSchedule: "Calendário de Vesting",
    snapshotDiff: "Diferença de Snapshots",
    taxEstimator: "Estimador de Impostos",
    multiSigTracker: "Rastreador Multi-Sig",
    yieldFarming: "Yield Farming",
    tokenFlow: "Fluxo de Tokens",
    plCalendar: "Calendário P&L",
    liquidationCalc: "Calculadora de Liquidação",
    smartMoneyFeed: "Feed Smart Money",
    rebalanceAdvisor: "Consultor de Rebalanceamento",
    benchmarkChart: "Gráfico Benchmark",
    tokenUnlocks: "Desbloqueio de Tokens",
    walletAnalytics: "Análise de Carteiras",
    protocolRevenue: "Receita do Protocolo",
    supplied: "Fornecido", borrowed: "Emprestado", netYield: "Rendimento Líquido",
    claimNow: "Resgatar Agora", claimed: "Resgatado", upcoming: "Em breve",
    safe: "Seguro", warning: "Aviso", danger: "Perigo",
    active: "Ativo", passed: "Aprovado", failed: "Falhou",
    currentPrice: "Preço Atual", confidence: "Confiança",
    safetyScore: "Score de Segurança", overallGrade: "Nota Geral",
    daily: "Diário", monthly: "Mensal", yearly: "Anual",
    current: "Atual", compare: "Comparar",
    high: "Alto", low: "Baixo", avg: "Média",
    buy: "Comprar", sell: "Vender", all: "Todos",
    claimable: "Resgatável", risky: "arriscado", revoke: "Revogar",
    networks: "redes", extracted: "extraído", bridged: "transferido",
    pending: "Pendente", done: "Feito",
    storage: "Armazenamento", access: "Acesso", backup: "Backup",
    phishing: "Phishing", smartContracts: "Contratos Inteligentes",
    notFinancialAdvice: "Simulado por IA · Não é conselho financeiro",
    extremeFear: "Medo Extremo", neutral: "Neutro", greed: "Ganância",
    extremeGreed: "Ganância Extrema", fear: "Medo", scan: "Escanear",
    positionSize: "Tamanho da Posição", maxLoss: "Perda Máxima",
    leverage: "Alavancagem", slDistance: "Distância SL",
    capital: "Capital", risk: "Risco", entryPrice: "Preço de Entrada",
    stopLoss: "Stop Loss", trend: "Tendência",
    uptrend: "↑ Alta", downtrend: "↓ Baixa", units: "Unidades",
    longPosition: "Long", shortPosition: "Short",
    totalValue: "Valor Total do Portfólio",
    walletCount: "Carteiras", chainCount: "Redes",
    export: "Exportar", add: "Adicionar", remove: "Remover", customize: "Personalizar",
    noGroupsYet: "Sem grupos ainda. Crie um para organizar suas carteiras.",
    onlySendAssets: "Envie apenas ativos {chain} para este endereço",
    highLeverage: "Alta alavancagem — risco elevado de liquidação",
    gasAboveAvg: "Gas acima da média", gasBelowAvg: "Gas abaixo da média",
    longsPaying: "Longs pagando shorts — viés altista",
    shortsPaying: "Shorts pagando longs — viés baixista",
    flashLoanWarning: "Flash loans podem indicar arbitragem ou liquidações",
    approvalRevoked: "Aprovação revogada (simulada)",
    allRevoked: "Todas as aprovações revogadas!",
    reputationScore: "Pontuação de Reputação",
    portfolioSnapshots: "Instantâneos do Portfólio",
    allowanceRevoker: "Revogador de Permissões",
    whaleAlertFeed: "Feed de Alertas Baleias",
    multiChainGas: "Gas Multi-Rede",
    yieldAggregator: "Agregador de Rendimentos",
    insuranceTracker: "Rastreador de Seguros DeFi",
    tokenBurnTracker: "Rastreador de Queimas",
    chainComparison: "Comparação de Redes",
    nftFloorTracker: "Rastreador de Floor NFT",
    yieldOptimizerBot: "Bot Otimizador de Yield",
    taxLossHarvesting: "Colheita de Perdas Fiscais",
    perpetualsDashboard: "Painel de Perpétuos",
    nftLendingMonitor: "Monitor de Empréstimos NFT",
    cryptoOptionsFlow: "Fluxo de Opções",
    walletMigrationPlanner: "Planejador de Migração",
    realYieldTracker: "Rastreador de Yield Real",
    governancePowerAnalyzer: "Analisador de Poder de Governança",
    protocolAuditDashboard: "Painel de Auditorias",
    dexVolumeAnalytics: "Análise de Volume DEX",
    walletAgeAnalyzer: "Analisador de Idade da Carteira",
    restakingDashboard: "Painel de Restaking",
    pointsProgramTracker: "Rastreador de Pontos",
    memecoinScanner: "Scanner de Memecoins",
    healthFactor: "Fator de Saúde",
    fundingRate: "Taxa de Financiamento",
    slashRisk: "Risco de Slash",
    honeypot: "Honeypot",
    rugScore: "Score de Rug",
    auditor: "Auditor",
    bounty: "Bug Bounty",
    realYield: "Yield Real",
    season: "Temporada",
    rank: "Posição",
    votingPower: "Poder de Voto",
    burnRate: "Taxa de Queima",
    floorPrice: "Preço Floor",
    holders: "Detentores",
    collateral: "Colateral",
    ltv: "LTV",
    impliedVol: "Vol. Implícita",
    tier: "Nível",
    delegated: "Delegado",
    marketShare: "Participação de Mercado",
    openInterest: "Interesse Aberto",
    verified: "Verificado",
    unaudited: "Não Auditado",
    realYieldDesc: "Protocolos por yield real (taxas − emissões)",
    noHoneypot: "Sem Honeypot",
    critical: "Crítico",
    findings: "Descobertas",
  },
  fr: {
    tokenComparison: "Comparaison de Tokens",
    walletGroups: "Groupes de Portefeuilles",
    gasHistory: "Historique Gas (24h)",
    takeProfitStrategy: "Stratégie Take-Profit",
    portfolioReport: "Rapport de Portfolio",
    lendingPositions: "Positions de Prêt",
    receiveCrypto: "Recevoir des Cryptos",
    bridgeTracker: "Suivi des Bridges",
    fundingRates: "Taux de Financement",
    governanceVotes: "Votes de Gouvernance",
    airdropTracker: "Suivi des Airdrops",
    tokenApprovals: "Approbations de Tokens",
    volumeProfile: "Profil de Volume",
    crossChainSummary: "Résumé Multi-Chaînes",
    transactionLabels: "Étiquettes de Transactions",
    performanceLeaderboard: "Classement des Performances",
    rewardCalendar: "Calendrier des Récompenses",
    whaleTracker: "Suivi des Baleines",
    dexRateComparison: "Comparaison des DEX",
    positionSizeCalc: "Calculateur de Position",
    fearGreedIndex: "Indice Peur & Avidité",
    contractInspector: "Inspecteur de Contrats",
    passiveIncome: "Revenus Passifs",
    portfolioVersions: "Versions du Portfolio",
    flashLoanMonitor: "Moniteur de Flash Loans",
    liquidationFeed: "Flux de Liquidations",
    fibonacciRetracement: "Retracement Fibonacci",
    stablecoinMonitor: "Moniteur de Stablecoins",
    pricePredictions: "Prédictions de Prix",
    securityChecklist: "Checklist de Sécurité",
    watchlist: "Liste de Suivi", cryptoConverter: "Convertisseur Crypto",
    addressBook: "Carnet d'Adresses", whaleAlerts: "Alertes Baleines",
    portfolioTimeline: "Chronologie", gasEstimator: "Estimateur de Gas",
    walletComparison: "Comparaison de Portefeuilles", walletBackup: "Sauvegarde",
    tokenAggregator: "Agrégateur de Tokens", activityHeatmap: "Carte d'Activité",
    riskScore: "Score de Risque", chainHistory: "Historique de Chaîne",
    sentiment: "Sentiment", feeTracker: "Suivi des Frais",
    achievements: "Réalisations", portfolioDonut: "Distribution du Portfolio",
    sharePortfolio: "Partager le Portfolio", eventCountdown: "Compte à Rebours",
    chainHealth: "Santé des Chaînes", stakingCalculator: "Calculateur de Staking",
    impermanentLoss: "Perte Impermanente", dcaSimulator: "Simulateur DCA",
    correlationMatrix: "Matrice de Corrélation", goalTracker: "Suivi d'Objectifs",
    vestingSchedule: "Calendrier de Vesting", snapshotDiff: "Diff de Snapshots",
    taxEstimator: "Estimateur d'Impôts", multiSigTracker: "Suivi Multi-Sig",
    yieldFarming: "Yield Farming", tokenFlow: "Flux de Tokens",
    plCalendar: "Calendrier P&L", liquidationCalc: "Calculateur de Liquidation",
    smartMoneyFeed: "Flux Smart Money", rebalanceAdvisor: "Conseiller de Rééquilibrage",
    benchmarkChart: "Graphique Benchmark", tokenUnlocks: "Déblocage de Tokens",
    walletAnalytics: "Analytique des Portefeuilles", protocolRevenue: "Revenus du Protocole",
    supplied: "Fourni", borrowed: "Emprunté", netYield: "Rendement Net",
    claimNow: "Réclamer", claimed: "Réclamé", upcoming: "À venir",
    safe: "Sûr", warning: "Attention", danger: "Danger",
    active: "Actif", passed: "Adopté", failed: "Rejeté",
    currentPrice: "Prix Actuel", confidence: "Confiance",
    safetyScore: "Score de Sécurité", overallGrade: "Note Globale",
    daily: "Quotidien", monthly: "Mensuel", yearly: "Annuel",
    current: "Actuel", compare: "Comparer",
    high: "Haut", low: "Bas", avg: "Moy.",
    buy: "Acheter", sell: "Vendre", all: "Tout",
    claimable: "Réclamable", risky: "risqué", revoke: "Révoquer",
    networks: "réseaux", extracted: "extrait", bridged: "transféré",
    pending: "En attente", done: "Terminé",
    storage: "Stockage", access: "Accès", backup: "Sauvegarde",
    phishing: "Hameçonnage", smartContracts: "Contrats Intelligents",
    notFinancialAdvice: "Simulé par IA · Pas un conseil financier",
    extremeFear: "Peur Extrême", neutral: "Neutre", greed: "Avidité",
    extremeGreed: "Avidité Extrême", fear: "Peur", scan: "Scanner",
    positionSize: "Taille de Position", maxLoss: "Perte Max",
    leverage: "Levier", slDistance: "Distance SL",
    capital: "Capital", risk: "Risque", entryPrice: "Prix d'Entrée",
    stopLoss: "Stop Loss", trend: "Tendance",
    uptrend: "↑ Hausse", downtrend: "↓ Baisse", units: "Unités",
    longPosition: "Long", shortPosition: "Short",
    totalValue: "Valeur Totale du Portfolio",
    walletCount: "Portefeuilles", chainCount: "Chaînes",
    export: "Exporter", add: "Ajouter", remove: "Supprimer", customize: "Personnaliser",
    noGroupsYet: "Pas encore de groupes. Créez-en un pour organiser vos portefeuilles.",
    onlySendAssets: "Envoyez uniquement des actifs {chain} à cette adresse",
    highLeverage: "Levier élevé — risque de liquidation accru",
    gasAboveAvg: "Gas au-dessus de la moyenne", gasBelowAvg: "Gas en-dessous de la moyenne",
    longsPaying: "Longs payant les shorts — biais haussier",
    shortsPaying: "Shorts payant les longs — biais baissier",
    flashLoanWarning: "Les flash loans peuvent indiquer des arbitrages ou liquidations",
    approvalRevoked: "Approbation révoquée (simulée)",
    allRevoked: "Toutes les approbations révoquées !",
    reputationScore: "Score de Réputation",
    portfolioSnapshots: "Instantanés du Portfolio",
    allowanceRevoker: "Révocateur d'Autorisations",
    whaleAlertFeed: "Flux d'Alertes Baleines",
    multiChainGas: "Gas Multi-Chaînes",
    yieldAggregator: "Agrégateur de Rendements",
    insuranceTracker: "Assurance DeFi",
    tokenBurnTracker: "Suivi des Brûlages",
    chainComparison: "Comparaison des Chaînes",
    nftFloorTracker: "Suivi Floor NFT",
    yieldOptimizerBot: "Bot Optimiseur de Yield",
    taxLossHarvesting: "Récolte des Pertes Fiscales",
    perpetualsDashboard: "Tableau de Bord Perpétuels",
    nftLendingMonitor: "Moniteur de Prêts NFT",
    cryptoOptionsFlow: "Flux d'Options",
    walletMigrationPlanner: "Planificateur de Migration",
    realYieldTracker: "Suivi du Rendement Réel",
    governancePowerAnalyzer: "Analyseur de Gouvernance",
    protocolAuditDashboard: "Tableau de Bord Audits",
    dexVolumeAnalytics: "Analyse du Volume DEX",
    walletAgeAnalyzer: "Analyseur d'Âge du Portefeuille",
    restakingDashboard: "Tableau de Bord Restaking",
    pointsProgramTracker: "Suivi des Programmes de Points",
    memecoinScanner: "Scanner de Memecoins",
    healthFactor: "Facteur de Santé",
    fundingRate: "Taux de Financement",
    slashRisk: "Risque de Slash",
    honeypot: "Honeypot",
    rugScore: "Score Rug",
    auditor: "Auditeur",
    bounty: "Bug Bounty",
    realYield: "Rendement Réel",
    season: "Saison",
    rank: "Rang",
    votingPower: "Pouvoir de Vote",
    burnRate: "Taux de Brûlage",
    floorPrice: "Prix Plancher",
    holders: "Détenteurs",
    collateral: "Garantie",
    ltv: "LTV",
    impliedVol: "Vol. Implicite",
    tier: "Niveau",
    delegated: "Délégué",
    marketShare: "Part de Marché",
    openInterest: "Intérêt Ouvert",
    verified: "Vérifié",
    unaudited: "Non Audité",
    realYieldDesc: "Protocoles par rendement réel (frais − émissions)",
    noHoneypot: "Pas de Honeypot",
    critical: "Critique",
    findings: "Résultats",
  },
  ru: {
    tokenComparison: "Сравнение токенов",
    walletGroups: "Группы кошельков",
    gasHistory: "История цен Gas (24ч)",
    takeProfitStrategy: "Стратегия тейк-профита",
    portfolioReport: "Отчёт портфеля",
    lendingPositions: "Позиции кредитования",
    receiveCrypto: "Получить криптовалюту",
    bridgeTracker: "Трекер мостов",
    fundingRates: "Ставки финансирования",
    governanceVotes: "Голосования управления",
    airdropTracker: "Трекер аирдропов",
    tokenApprovals: "Одобрения токенов",
    volumeProfile: "Профиль объёма",
    crossChainSummary: "Мультичейн сводка",
    transactionLabels: "Метки транзакций",
    performanceLeaderboard: "Таблица лидеров",
    rewardCalendar: "Календарь наград",
    whaleTracker: "Трекер китов",
    dexRateComparison: "Сравнение DEX",
    positionSizeCalc: "Калькулятор позиции",
    fearGreedIndex: "Индекс страха и жадности",
    contractInspector: "Инспектор контрактов",
    passiveIncome: "Пассивный доход",
    portfolioVersions: "Версии портфеля",
    flashLoanMonitor: "Монитор флеш-займов",
    liquidationFeed: "Лента ликвидаций",
    fibonacciRetracement: "Откат Фибоначчи",
    stablecoinMonitor: "Монитор стейблкоинов",
    pricePredictions: "Прогнозы цен",
    securityChecklist: "Чеклист безопасности",
    watchlist: "Список наблюдения", cryptoConverter: "Крипто-конвертер",
    addressBook: "Адресная книга", whaleAlerts: "Оповещения о китах",
    portfolioTimeline: "Хронология", gasEstimator: "Оценка Gas",
    walletComparison: "Сравнение кошельков", walletBackup: "Резервная копия",
    tokenAggregator: "Агрегатор токенов", activityHeatmap: "Карта активности",
    riskScore: "Оценка риска", chainHistory: "История сети",
    sentiment: "Настроение", feeTracker: "Трекер комиссий",
    achievements: "Достижения", portfolioDonut: "Распределение портфеля",
    sharePortfolio: "Поделиться портфелем", eventCountdown: "Обратный отсчёт",
    chainHealth: "Здоровье сети", stakingCalculator: "Калькулятор стейкинга",
    impermanentLoss: "Непостоянные потери", dcaSimulator: "Симулятор DCA",
    correlationMatrix: "Матрица корреляции", goalTracker: "Трекер целей",
    vestingSchedule: "График вестинга", snapshotDiff: "Разница снимков",
    taxEstimator: "Оценка налогов", multiSigTracker: "Трекер мультиподписей",
    yieldFarming: "Фарминг доходности", tokenFlow: "Поток токенов",
    plCalendar: "Календарь P&L", liquidationCalc: "Калькулятор ликвидации",
    smartMoneyFeed: "Лента умных денег", rebalanceAdvisor: "Советник ребалансировки",
    benchmarkChart: "График бенчмарка", tokenUnlocks: "Разблокировка токенов",
    walletAnalytics: "Аналитика кошельков", protocolRevenue: "Доход протокола",
    supplied: "Предоставлено", borrowed: "Заимствовано", netYield: "Чистый доход",
    claimNow: "Забрать сейчас", claimed: "Забрано", upcoming: "Скоро",
    safe: "Безопасно", warning: "Внимание", danger: "Опасно",
    active: "Активно", passed: "Принято", failed: "Отклонено",
    currentPrice: "Текущая цена", confidence: "Уверенность",
    safetyScore: "Оценка безопасности", overallGrade: "Общая оценка",
    daily: "Ежедневно", monthly: "Ежемесячно", yearly: "Ежегодно",
    current: "Текущий", compare: "Сравнить",
    high: "Макс", low: "Мин", avg: "Сред.",
    buy: "Купить", sell: "Продать", all: "Все",
    claimable: "Доступно", risky: "рискованно", revoke: "Отозвать",
    networks: "сетей", extracted: "извлечено", bridged: "переведено",
    pending: "Ожидание", done: "Готово",
    storage: "Хранение", access: "Доступ", backup: "Резервная копия",
    phishing: "Фишинг", smartContracts: "Смарт-контракты",
    notFinancialAdvice: "AI симуляция · Не финансовый совет",
    extremeFear: "Крайний страх", neutral: "Нейтрально", greed: "Жадность",
    extremeGreed: "Крайняя жадность", fear: "Страх", scan: "Сканировать",
    positionSize: "Размер позиции", maxLoss: "Макс. убыток",
    leverage: "Плечо", slDistance: "Расстояние SL",
    capital: "Капитал", risk: "Риск", entryPrice: "Цена входа",
    stopLoss: "Стоп-лосс", trend: "Тренд",
    uptrend: "↑ Восходящий", downtrend: "↓ Нисходящий", units: "Единицы",
    longPosition: "Лонг", shortPosition: "Шорт",
    totalValue: "Общая стоимость портфеля",
    walletCount: "Кошельков", chainCount: "Сетей",
    export: "Экспорт", add: "Добавить", remove: "Удалить", customize: "Настроить",
    noGroupsYet: "Нет групп. Создайте группу для организации кошельков.",
    onlySendAssets: "Отправляйте только {chain} активы на этот адрес",
    highLeverage: "Высокое плечо — повышенный риск ликвидации",
    gasAboveAvg: "Gas выше среднего", gasBelowAvg: "Gas ниже среднего",
    longsPaying: "Лонги платят шортам — бычий настрой",
    shortsPaying: "Шорты платят лонгам — медвежий настрой",
    flashLoanWarning: "Флеш-займы могут указывать на арбитраж или ликвидацию",
    approvalRevoked: "Одобрение отозвано (симуляция)",
    allRevoked: "Все одобрения отозваны!",
    reputationScore: "Оценка репутации",
    portfolioSnapshots: "Снимки портфеля",
    allowanceRevoker: "Отзыв разрешений",
    whaleAlertFeed: "Лента оповещений о китах",
    multiChainGas: "Gas в мультичейне",
    yieldAggregator: "Агрегатор доходности",
    insuranceTracker: "Страхование DeFi",
    tokenBurnTracker: "Трекер сжигания токенов",
    chainComparison: "Сравнение сетей",
    nftFloorTracker: "Трекер флор-цен NFT",
    yieldOptimizerBot: "Бот оптимизации доходности",
    taxLossHarvesting: "Налоговая оптимизация убытков",
    perpetualsDashboard: "Панель бессрочных",
    nftLendingMonitor: "Монитор займов NFT",
    cryptoOptionsFlow: "Поток опционов",
    walletMigrationPlanner: "Планировщик миграции",
    realYieldTracker: "Трекер реальной доходности",
    governancePowerAnalyzer: "Анализатор власти управления",
    protocolAuditDashboard: "Панель аудитов",
    dexVolumeAnalytics: "Аналитика объёма DEX",
    walletAgeAnalyzer: "Анализатор возраста кошелька",
    restakingDashboard: "Панель рестейкинга",
    pointsProgramTracker: "Трекер программ очков",
    memecoinScanner: "Сканер мемкоинов",
    healthFactor: "Коэффициент здоровья",
    fundingRate: "Ставка финансирования",
    slashRisk: "Риск слэша",
    honeypot: "Ловушка (honeypot)",
    rugScore: "Оценка скама",
    auditor: "Аудитор",
    bounty: "Вознаграждение за баги",
    realYield: "Реальная доходность",
    season: "Сезон",
    rank: "Ранг",
    votingPower: "Сила голоса",
    burnRate: "Скорость сжигания",
    floorPrice: "Флор-цена",
    holders: "Держатели",
    collateral: "Залог",
    ltv: "LTV",
    impliedVol: "Имплицитная волатильность",
    tier: "Уровень",
    delegated: "Делегировано",
    marketShare: "Доля рынка",
    openInterest: "Открытый интерес",
    verified: "Верифицировано",
    unaudited: "Без аудита",
    realYieldDesc: "Протоколы по реальной доходности (комиссии − эмиссия)",
    noHoneypot: "Без ловушки",
    critical: "Критический",
    findings: "Находки",
  },
  ja: {
    tokenComparison: "トークン比較",
    walletGroups: "ウォレットグループ",
    gasHistory: "Gas価格履歴 (24時間)",
    takeProfitStrategy: "利確戦略",
    portfolioReport: "ポートフォリオレポート",
    lendingPositions: "レンディングポジション",
    receiveCrypto: "暗号通貨を受け取る",
    bridgeTracker: "ブリッジトラッカー",
    fundingRates: "資金調達率",
    governanceVotes: "ガバナンス投票",
    airdropTracker: "エアドロップトラッカー",
    tokenApprovals: "トークン承認",
    volumeProfile: "出来高プロファイル",
    crossChainSummary: "クロスチェーンサマリー",
    transactionLabels: "トランザクションラベル",
    performanceLeaderboard: "パフォーマンスランキング",
    rewardCalendar: "報酬カレンダー",
    whaleTracker: "クジラトラッカー",
    dexRateComparison: "DEXレート比較",
    positionSizeCalc: "ポジションサイズ計算機",
    fearGreedIndex: "恐怖＆強欲指数",
    contractInspector: "コントラクト検査",
    passiveIncome: "パッシブインカム",
    portfolioVersions: "ポートフォリオバージョン",
    flashLoanMonitor: "フラッシュローン監視",
    liquidationFeed: "清算フィード",
    fibonacciRetracement: "フィボナッチリトレースメント",
    stablecoinMonitor: "ステーブルコイン監視",
    pricePredictions: "価格予測",
    securityChecklist: "セキュリティチェックリスト",
    watchlist: "ウォッチリスト", cryptoConverter: "暗号通貨コンバーター",
    addressBook: "アドレス帳", whaleAlerts: "クジラアラート",
    portfolioTimeline: "タイムライン", gasEstimator: "Gas見積もり",
    walletComparison: "ウォレット比較", walletBackup: "バックアップ",
    tokenAggregator: "トークンアグリゲーター", activityHeatmap: "活動ヒートマップ",
    riskScore: "リスクスコア", chainHistory: "チェーン履歴",
    sentiment: "市場心理", feeTracker: "手数料トラッカー",
    achievements: "実績", portfolioDonut: "分布図",
    sharePortfolio: "ポートフォリオ共有", eventCountdown: "カウントダウン",
    chainHealth: "チェーンの健全性", stakingCalculator: "ステーキング計算機",
    impermanentLoss: "インパーマネントロス", dcaSimulator: "DCAシミュレーター",
    correlationMatrix: "相関マトリックス", goalTracker: "目標トラッカー",
    vestingSchedule: "ベスティングスケジュール", snapshotDiff: "スナップショット差分",
    taxEstimator: "税金見積もり", multiSigTracker: "マルチシグトラッカー",
    yieldFarming: "イールドファーミング", tokenFlow: "トークンフロー",
    plCalendar: "損益カレンダー", liquidationCalc: "清算計算機",
    smartMoneyFeed: "スマートマネーフィード", rebalanceAdvisor: "リバランスアドバイザー",
    benchmarkChart: "ベンチマークチャート", tokenUnlocks: "トークンアンロック",
    walletAnalytics: "ウォレット分析", protocolRevenue: "プロトコル収益",
    supplied: "供給", borrowed: "借入", netYield: "純利回り",
    claimNow: "今すぐ請求", claimed: "請求済み", upcoming: "近日公開",
    safe: "安全", warning: "注意", danger: "危険",
    active: "アクティブ", passed: "可決", failed: "否決",
    currentPrice: "現在価格", confidence: "信頼度",
    safetyScore: "安全スコア", overallGrade: "総合評価",
    daily: "日次", monthly: "月次", yearly: "年次",
    current: "現在", compare: "比較",
    high: "高値", low: "安値", avg: "平均",
    buy: "買い", sell: "売り", all: "全て",
    claimable: "請求可能", risky: "リスク", revoke: "取り消し",
    networks: "ネットワーク", extracted: "抽出", bridged: "ブリッジ済み",
    pending: "保留中", done: "完了",
    storage: "ストレージ", access: "アクセス", backup: "バックアップ",
    phishing: "フィッシング", smartContracts: "スマートコントラクト",
    notFinancialAdvice: "AIシミュレーション・投資助言ではありません",
    extremeFear: "極度の恐怖", neutral: "中立", greed: "強欲",
    extremeGreed: "極度の強欲", fear: "恐怖", scan: "スキャン",
    positionSize: "ポジションサイズ", maxLoss: "最大損失",
    leverage: "レバレッジ", slDistance: "SL距離",
    capital: "資金", risk: "リスク", entryPrice: "エントリー価格",
    stopLoss: "ストップロス", trend: "トレンド",
    uptrend: "↑ 上昇トレンド", downtrend: "↓ 下降トレンド", units: "数量",
    longPosition: "ロング", shortPosition: "ショート",
    totalValue: "ポートフォリオ総額",
    walletCount: "ウォレット", chainCount: "チェーン",
    export: "エクスポート", add: "追加", remove: "削除", customize: "カスタマイズ",
    noGroupsYet: "グループがありません。ウォレットを整理するために作成してください。",
    onlySendAssets: "このアドレスには{chain}の資産のみ送信してください",
    highLeverage: "高レバレッジ — 清算リスクが上昇",
    gasAboveAvg: "Gasが平均以上", gasBelowAvg: "Gasが平均以下",
    longsPaying: "ロングがショートに支払い — 強気傾向",
    shortsPaying: "ショートがロングに支払い — 弱気傾向",
    flashLoanWarning: "フラッシュローンはアービトラージや清算を示す可能性があります",
    approvalRevoked: "承認が取り消されました（シミュレーション）",
    allRevoked: "すべての承認が取り消されました！",
    reputationScore: "評判スコア",
    portfolioSnapshots: "ポートフォリオスナップショット",
    allowanceRevoker: "許可取消ツール",
    whaleAlertFeed: "クジラアラートフィード",
    multiChainGas: "マルチチェーンGas",
    yieldAggregator: "イールドアグリゲーター",
    insuranceTracker: "DeFi保険トラッカー",
    tokenBurnTracker: "トークン焼却トラッカー",
    chainComparison: "チェーン比較",
    nftFloorTracker: "NFTフロア価格トラッカー",
    yieldOptimizerBot: "イールド最適化ボット",
    taxLossHarvesting: "税損失収穫",
    perpetualsDashboard: "無期限先物ダッシュボード",
    nftLendingMonitor: "NFTレンディングモニター",
    cryptoOptionsFlow: "オプションフロートラッカー",
    walletMigrationPlanner: "ウォレット移行プランナー",
    realYieldTracker: "実質利回りトラッカー",
    governancePowerAnalyzer: "ガバナンスパワー分析",
    protocolAuditDashboard: "監査ダッシュボード",
    dexVolumeAnalytics: "DEX出来高分析",
    walletAgeAnalyzer: "ウォレット年齢分析",
    restakingDashboard: "リステーキングダッシュボード",
    pointsProgramTracker: "ポイントプログラム追跡",
    memecoinScanner: "ミームコインスキャナー",
    healthFactor: "ヘルスファクター",
    fundingRate: "資金調達率",
    slashRisk: "スラッシュリスク",
    honeypot: "ハニーポット",
    rugScore: "ラグスコア",
    auditor: "監査機関",
    bounty: "バグバウンティ",
    realYield: "実質利回り",
    season: "シーズン",
    rank: "ランク",
    votingPower: "投票権",
    burnRate: "焼却率",
    floorPrice: "フロア価格",
    holders: "保有者",
    collateral: "担保",
    ltv: "担保率",
    impliedVol: "インプライドボラティリティ",
    tier: "ティア",
    delegated: "委任済み",
    marketShare: "市場シェア",
    openInterest: "建玉",
    verified: "検証済み",
    unaudited: "未監査",
    realYieldDesc: "実質利回りでランク付けされたプロトコル",
    noHoneypot: "ハニーポットなし",
    critical: "クリティカル",
    findings: "発見事項",
  },
  de: {
    tokenComparison: "Token-Vergleich",
    walletGroups: "Wallet-Gruppen",
    gasHistory: "Gas-Preisverlauf (24h)",
    takeProfitStrategy: "Take-Profit-Strategie",
    portfolioReport: "Portfolio-Bericht",
    lendingPositions: "Leih-Positionen",
    receiveCrypto: "Krypto empfangen",
    bridgeTracker: "Bridge-Tracker",
    fundingRates: "Finanzierungsraten",
    governanceVotes: "Governance-Abstimmungen",
    airdropTracker: "Airdrop-Tracker",
    tokenApprovals: "Token-Genehmigungen",
    volumeProfile: "Volumenprofil",
    crossChainSummary: "Multi-Chain-Übersicht",
    transactionLabels: "Transaktions-Labels",
    performanceLeaderboard: "Leistungs-Rangliste",
    rewardCalendar: "Belohnungs-Kalender",
    whaleTracker: "Wal-Tracker",
    dexRateComparison: "DEX-Kursvergleich",
    positionSizeCalc: "Positionsgrößen-Rechner",
    fearGreedIndex: "Angst-&-Gier-Index",
    contractInspector: "Vertrags-Inspektor",
    passiveIncome: "Passives Einkommen",
    portfolioVersions: "Portfolio-Versionen",
    flashLoanMonitor: "Flash-Loan-Monitor",
    liquidationFeed: "Liquidations-Feed",
    fibonacciRetracement: "Fibonacci-Retracement",
    stablecoinMonitor: "Stablecoin-Monitor",
    pricePredictions: "Preis-Vorhersagen",
    securityChecklist: "Sicherheits-Checkliste",
    watchlist: "Beobachtungsliste", cryptoConverter: "Krypto-Konverter",
    addressBook: "Adressbuch", whaleAlerts: "Wal-Alarme",
    portfolioTimeline: "Zeitachse", gasEstimator: "Gas-Schätzung",
    walletComparison: "Wallet-Vergleich", walletBackup: "Wallet-Sicherung",
    tokenAggregator: "Token-Aggregator", activityHeatmap: "Aktivitäts-Heatmap",
    riskScore: "Risikobewertung", chainHistory: "Chain-Verlauf",
    sentiment: "Stimmung", feeTracker: "Gebühren-Tracker",
    achievements: "Erfolge", portfolioDonut: "Portfolio-Verteilung",
    sharePortfolio: "Portfolio teilen", eventCountdown: "Countdown",
    chainHealth: "Chain-Gesundheit", stakingCalculator: "Staking-Rechner",
    impermanentLoss: "Impermanenter Verlust", dcaSimulator: "DCA-Simulator",
    correlationMatrix: "Korrelationsmatrix", goalTracker: "Ziel-Tracker",
    vestingSchedule: "Vesting-Zeitplan", snapshotDiff: "Snapshot-Diff",
    taxEstimator: "Steuer-Schätzung", multiSigTracker: "Multi-Sig-Tracker",
    yieldFarming: "Yield Farming", tokenFlow: "Token-Fluss",
    plCalendar: "G&V-Kalender", liquidationCalc: "Liquidations-Rechner",
    smartMoneyFeed: "Smart-Money-Feed", rebalanceAdvisor: "Rebalancing-Berater",
    benchmarkChart: "Benchmark-Chart", tokenUnlocks: "Token-Freigaben",
    walletAnalytics: "Wallet-Analytik", protocolRevenue: "Protokoll-Einnahmen",
    supplied: "Bereitgestellt", borrowed: "Geliehen", netYield: "Nettorendite",
    claimNow: "Jetzt beanspruchen", claimed: "Beansprucht", upcoming: "Demnächst",
    safe: "Sicher", warning: "Warnung", danger: "Gefahr",
    active: "Aktiv", passed: "Angenommen", failed: "Abgelehnt",
    currentPrice: "Aktueller Preis", confidence: "Vertrauen",
    safetyScore: "Sicherheitsbewertung", overallGrade: "Gesamtnote",
    daily: "Täglich", monthly: "Monatlich", yearly: "Jährlich",
    current: "Aktuell", compare: "Vergleichen",
    high: "Hoch", low: "Tief", avg: "Durchschn.",
    buy: "Kaufen", sell: "Verkaufen", all: "Alle",
    claimable: "Verfügbar", risky: "riskant", revoke: "Widerrufen",
    networks: "Netzwerke", extracted: "extrahiert", bridged: "überbrückt",
    pending: "Ausstehend", done: "Fertig",
    storage: "Speicherung", access: "Zugang", backup: "Sicherung",
    phishing: "Phishing", smartContracts: "Smart Contracts",
    notFinancialAdvice: "KI-Simulation · Keine Finanzberatung",
    extremeFear: "Extreme Angst", neutral: "Neutral", greed: "Gier",
    extremeGreed: "Extreme Gier", fear: "Angst", scan: "Scannen",
    positionSize: "Positionsgröße", maxLoss: "Max. Verlust",
    leverage: "Hebel", slDistance: "SL-Abstand",
    capital: "Kapital", risk: "Risiko", entryPrice: "Einstiegspreis",
    stopLoss: "Stop-Loss", trend: "Trend",
    uptrend: "↑ Aufwärtstrend", downtrend: "↓ Abwärtstrend", units: "Einheiten",
    longPosition: "Long", shortPosition: "Short",
    totalValue: "Gesamtwert des Portfolios",
    walletCount: "Wallets", chainCount: "Chains",
    export: "Exportieren", add: "Hinzufügen", remove: "Entfernen", customize: "Anpassen",
    noGroupsYet: "Noch keine Gruppen. Erstelle eine, um deine Wallets zu organisieren.",
    onlySendAssets: "Sende nur {chain}-Assets an diese Adresse",
    highLeverage: "Hoher Hebel — erhöhtes Liquidationsrisiko",
    gasAboveAvg: "Gas über dem Durchschnitt", gasBelowAvg: "Gas unter dem Durchschnitt",
    longsPaying: "Longs zahlen Shorts — bullisher Bias",
    shortsPaying: "Shorts zahlen Longs — bearisher Bias",
    flashLoanWarning: "Flash Loans können auf Arbitrage oder Liquidationen hinweisen",
    approvalRevoked: "Genehmigung widerrufen (simuliert)",
    allRevoked: "Alle Genehmigungen widerrufen!",
    reputationScore: "Reputationsbewertung",
    portfolioSnapshots: "Portfolio-Snapshots",
    allowanceRevoker: "Genehmigungen widerrufen",
    whaleAlertFeed: "Wal-Alert-Feed",
    multiChainGas: "Multi-Chain Gas",
    yieldAggregator: "Rendite-Aggregator",
    insuranceTracker: "DeFi-Versicherungs-Tracker",
    tokenBurnTracker: "Token-Burn-Tracker",
    chainComparison: "Netzwerk-Vergleich",
    nftFloorTracker: "NFT-Floor-Tracker",
    yieldOptimizerBot: "Rendite-Optimierungs-Bot",
    taxLossHarvesting: "Steuerverlustverwertung",
    perpetualsDashboard: "Perpetuals-Dashboard",
    nftLendingMonitor: "NFT-Kreditüberwachung",
    cryptoOptionsFlow: "Optionsfluss-Tracker",
    walletMigrationPlanner: "Wallet-Migrationsplaner",
    realYieldTracker: "Echtrendite-Tracker",
    governancePowerAnalyzer: "Governance-Macht-Analyse",
    protocolAuditDashboard: "Audit-Dashboard",
    dexVolumeAnalytics: "DEX-Volumen-Analyse",
    walletAgeAnalyzer: "Wallet-Alters-Analyse",
    restakingDashboard: "Restaking-Dashboard",
    pointsProgramTracker: "Punkteprogramm-Tracker",
    memecoinScanner: "Memecoin-Scanner",
    healthFactor: "Gesundheitsfaktor",
    fundingRate: "Finanzierungsrate",
    slashRisk: "Slash-Risiko",
    honeypot: "Honeypot",
    rugScore: "Rug-Score",
    auditor: "Prüfer",
    bounty: "Bug-Prämie",
    realYield: "Echtrendite",
    season: "Saison",
    rank: "Rang",
    votingPower: "Stimmkraft",
    burnRate: "Burn-Rate",
    floorPrice: "Floor-Preis",
    holders: "Inhaber",
    collateral: "Sicherheiten",
    ltv: "Beleihungsquote",
    impliedVol: "Implizite Vola",
    tier: "Stufe",
    delegated: "Delegiert",
    marketShare: "Marktanteil",
    openInterest: "Offenes Interesse",
    verified: "Verifiziert",
    unaudited: "Ungeprüft",
    realYieldDesc: "Protokolle nach Echtrendite (Gebühren − Emissionen)",
    noHoneypot: "Kein Honeypot",
    critical: "Kritisch",
    findings: "Befunde",
  },
  ko: {
    tokenComparison: "토큰 비교",
    walletGroups: "지갑 그룹",
    gasHistory: "Gas 가격 이력 (24시간)",
    takeProfitStrategy: "이익 실현 전략",
    portfolioReport: "포트폴리오 보고서",
    lendingPositions: "대출 포지션",
    receiveCrypto: "암호화폐 받기",
    bridgeTracker: "브리지 추적기",
    fundingRates: "펀딩 비율",
    governanceVotes: "거버넌스 투표",
    airdropTracker: "에어드롭 추적기",
    tokenApprovals: "토큰 승인",
    volumeProfile: "거래량 프로파일",
    crossChainSummary: "크로스체인 요약",
    transactionLabels: "거래 라벨",
    performanceLeaderboard: "성과 리더보드",
    rewardCalendar: "보상 캘린더",
    whaleTracker: "고래 추적기",
    dexRateComparison: "DEX 가격 비교",
    positionSizeCalc: "포지션 크기 계산기",
    fearGreedIndex: "공포 & 탐욕 지수",
    contractInspector: "컨트랙트 검사기",
    passiveIncome: "패시브 인컴",
    portfolioVersions: "포트폴리오 버전",
    flashLoanMonitor: "플래시 론 모니터",
    liquidationFeed: "청산 피드",
    fibonacciRetracement: "피보나치 되돌림",
    stablecoinMonitor: "스테이블코인 모니터",
    pricePredictions: "가격 예측",
    securityChecklist: "보안 체크리스트",
    watchlist: "관심 목록", cryptoConverter: "암호화폐 변환기",
    addressBook: "주소록", whaleAlerts: "고래 알림",
    portfolioTimeline: "타임라인", gasEstimator: "Gas 추정",
    walletComparison: "지갑 비교", walletBackup: "지갑 백업",
    tokenAggregator: "토큰 집계기", activityHeatmap: "활동 히트맵",
    riskScore: "리스크 점수", chainHistory: "체인 이력",
    sentiment: "시장 심리", feeTracker: "수수료 추적기",
    achievements: "업적", portfolioDonut: "포트폴리오 분포",
    sharePortfolio: "포트폴리오 공유", eventCountdown: "이벤트 카운트다운",
    chainHealth: "체인 상태", stakingCalculator: "스테이킹 계산기",
    impermanentLoss: "비영구적 손실", dcaSimulator: "DCA 시뮬레이터",
    correlationMatrix: "상관관계 매트릭스", goalTracker: "목표 추적기",
    vestingSchedule: "베스팅 일정", snapshotDiff: "스냅샷 차이",
    taxEstimator: "세금 추정", multiSigTracker: "멀티시그 추적기",
    yieldFarming: "일드 파밍", tokenFlow: "토큰 흐름",
    plCalendar: "손익 캘린더", liquidationCalc: "청산 계산기",
    smartMoneyFeed: "스마트머니 피드", rebalanceAdvisor: "리밸런싱 어드바이저",
    benchmarkChart: "벤치마크 차트", tokenUnlocks: "토큰 잠금 해제",
    walletAnalytics: "지갑 분석", protocolRevenue: "프로토콜 수익",
    supplied: "공급됨", borrowed: "차입됨", netYield: "순수익률",
    claimNow: "지금 청구", claimed: "청구됨", upcoming: "예정",
    safe: "안전", warning: "주의", danger: "위험",
    active: "활성", passed: "통과", failed: "실패",
    currentPrice: "현재 가격", confidence: "신뢰도",
    safetyScore: "안전 점수", overallGrade: "종합 등급",
    daily: "일일", monthly: "월간", yearly: "연간",
    current: "현재", compare: "비교",
    high: "고가", low: "저가", avg: "평균",
    buy: "매수", sell: "매도", all: "전체",
    claimable: "청구 가능", risky: "위험", revoke: "취소",
    networks: "네트워크", extracted: "추출됨", bridged: "브리지됨",
    pending: "대기 중", done: "완료",
    storage: "저장", access: "접근", backup: "백업",
    phishing: "피싱", smartContracts: "스마트 컨트랙트",
    notFinancialAdvice: "AI 시뮬레이션 · 투자 조언이 아닙니다",
    extremeFear: "극도의 공포", neutral: "중립", greed: "탐욕",
    extremeGreed: "극도의 탐욕", fear: "공포", scan: "스캔",
    positionSize: "포지션 크기", maxLoss: "최대 손실",
    leverage: "레버리지", slDistance: "SL 거리",
    capital: "자본", risk: "리스크", entryPrice: "진입 가격",
    stopLoss: "스톱로스", trend: "추세",
    uptrend: "↑ 상승 추세", downtrend: "↓ 하락 추세", units: "수량",
    longPosition: "롱", shortPosition: "숏",
    totalValue: "포트폴리오 총 가치",
    walletCount: "지갑", chainCount: "체인",
    export: "내보내기", add: "추가", remove: "삭제", customize: "사용자 정의",
    noGroupsYet: "아직 그룹이 없습니다. 지갑을 정리할 그룹을 만드세요.",
    onlySendAssets: "이 주소로 {chain} 자산만 보내세요",
    highLeverage: "높은 레버리지 — 청산 위험 증가",
    gasAboveAvg: "Gas가 평균 이상", gasBelowAvg: "Gas가 평균 이하",
    longsPaying: "롱이 숏에 지불 — 강세 편향",
    shortsPaying: "숏이 롱에 지불 — 약세 편향",
    flashLoanWarning: "플래시 론은 차익거래 또는 청산을 나타낼 수 있습니다",
    approvalRevoked: "승인이 취소되었습니다 (시뮬레이션)",
    allRevoked: "모든 승인이 취소되었습니다!",
    reputationScore: "평판 점수",
    portfolioSnapshots: "포트폴리오 스냅샷",
    allowanceRevoker: "권한 취소기",
    whaleAlertFeed: "고래 경보 피드",
    multiChainGas: "멀티체인 Gas",
    yieldAggregator: "수익 집계기",
    insuranceTracker: "DeFi 보험 추적기",
    tokenBurnTracker: "토큰 소각 추적기",
    chainComparison: "체인 비교",
    nftFloorTracker: "NFT 바닥가 추적기",
    yieldOptimizerBot: "수익 최적화 봇",
    taxLossHarvesting: "세금 손실 수확",
    perpetualsDashboard: "무기한 선물 대시보드",
    nftLendingMonitor: "NFT 대출 모니터",
    cryptoOptionsFlow: "옵션 플로우 추적기",
    walletMigrationPlanner: "지갑 마이그레이션 플래너",
    realYieldTracker: "실질 수익 추적기",
    governancePowerAnalyzer: "거버넌스 파워 분석",
    protocolAuditDashboard: "감사 대시보드",
    dexVolumeAnalytics: "DEX 거래량 분석",
    walletAgeAnalyzer: "지갑 연령 분석기",
    restakingDashboard: "리스테이킹 대시보드",
    pointsProgramTracker: "포인트 프로그램 추적기",
    memecoinScanner: "밈코인 스캐너",
    healthFactor: "건강 지수",
    fundingRate: "펀딩 비율",
    slashRisk: "슬래시 위험",
    honeypot: "허니팟",
    rugScore: "러그 점수",
    auditor: "감사기관",
    bounty: "버그 포상금",
    realYield: "실질 수익",
    season: "시즌",
    rank: "순위",
    votingPower: "투표권",
    burnRate: "소각률",
    floorPrice: "바닥 가격",
    holders: "보유자",
    collateral: "담보",
    ltv: "담보비율",
    impliedVol: "내재 변동성",
    tier: "등급",
    delegated: "위임됨",
    marketShare: "시장 점유율",
    openInterest: "미결제약정",
    verified: "검증됨",
    unaudited: "미감사",
    realYieldDesc: "실질 수익으로 순위 (수수료 − 발행)",
    noHoneypot: "허니팟 없음",
    critical: "심각",
    findings: "발견사항",
  },
};

export default componentTranslations;
